import { FC } from 'react';

const SectionHeadingV2: FC<{
  title: string;
  className?: string;
  showBorder?: boolean;
}> = ({ title, className, showBorder = true }) => {
  return (
    <div
      className={`pb-1 px-5 mt-5 ${
        showBorder ? 'border-b border-b-beige' : ''
      } ${className}`}
    >
      <h1 className="text-16-22-0.3 font-sohneKraftig">{title}</h1>
    </div>
  );
};

export default SectionHeadingV2;
